import { useBillingSubTab } from 'hooks/billingSubTab.hook';
import { useSelector } from 'react-redux';
import { RootState } from 'store/store';
import { Stack } from 'styles';
import { useBillingFilter } from './billingFilterHook';
import BillingFooter from './components/BillingFooter.component';
import BillingTable from './components/BillingTable.component';
import BillingTabs from './components/BillingTabs.component';

const ViewBillingPage: React.FC = () => {
	const { tabSelected, adminBillingStatuses, claimsBillingStatuses } =
		useSelector((store: RootState) => store.billing);

	const { isMembers } = useBillingSubTab();

	useBillingFilter();

	if (
		(tabSelected === 'admin' && adminBillingStatuses.length === 0) ||
		(tabSelected === 'claims' && claimsBillingStatuses.length === 0)
	) {
		return null;
	}

	let TABLE_HEIGHT = '';
	if (tabSelected === 'claims') {
		TABLE_HEIGHT = 'calc(100vh - 278px)';
	} else if (isMembers) {
		TABLE_HEIGHT = 'calc(100vh - 218px)';
	} else {
		TABLE_HEIGHT = 'calc(100vh - 320px)';
	}

	return (
		<Stack sx={{ width: '100%' }}>
			{!isMembers && <BillingTabs />}
			<Stack
				width={'100%'}
				height={TABLE_HEIGHT}
				overflow={'hidden'}
				alignContent={'space-between'}
			>
				<BillingTable />
				<BillingFooter />
			</Stack>
		</Stack>
	);
};

export default ViewBillingPage;
